import React from 'react';
import { connect } from 'react-redux';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';
import { AppState } from '../../common/redux/configure-store';
import Total from './total';

const TotalWrapper: React.FC<ITotalWrapperProps> = (props: ITotalWrapperProps): JSX.Element => {
  return (
    <Total
      subTotal={props.subTotal}
      tax={props.tax}
      savings={props.savings}
      ejItems={props.ejItems}
      currencyCode={props.currencyCode}
      trainingModeActive={props.trainingModeActive}
      returnModeActive={props.returnModeActive}
      isCustomerDisplay={props.isCustomerDisplay}
    />
  );
};

interface ITotalWrapperProps {
  subTotal: number;
  tax: number;
  savings: number;
  ejItems: IElectronicJournalRecord[];
  currencyCode: string;
  trainingModeActive: boolean;
  returnModeActive: any;
  isCustomerDisplay?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  subTotal: state.itemList.subTotal,
  tax: state.itemList.tax,
  savings: state.itemList.savings,
  ejItems: state.itemList.ejItems,
  currencyCode: state.itemList.currencyCode,
  hasSelectedTender: !!state.tenderMenu.selectedTender,
  trainingModeActive: state.posMode.trainingMode,
  returnModeActive: !!state.posMode.returnMode.returnType,
});

export default connect(mapStateToProps)(TotalWrapper);
